import { useMemo } from 'react';
import { usePlanEntitlements } from '../../shell/providers/PlanEntitlementsProvider';
import { useSessionStore } from '../../shell/session/store/useSessionStore';

export function resolveOwnerPanelAccess(
  isOwner: boolean,
  branches: Array<{ isActive?: boolean }>,
) {
  const activeBranchCount = branches.filter((branch) => branch.isActive !== false).length;
  return {
    canAccessOwnerPanel: isOwner && activeBranchCount >= 2,
    activeBranchCount,
    isOwner,
  };
}

export function useOwnerPanelAccess() {
  const branches = useSessionStore((s) => s.branches);
  const { entitlements } = usePlanEntitlements();
  const isOwner = entitlements?.is_owner === true;

  return useMemo(
    () => resolveOwnerPanelAccess(isOwner, branches),
    [branches, isOwner],
  );
}
